/*
 * Angular bootstrap dropdown directive is used as basis
 * The biggest difference- append dropdown menu to content to prevent overflow: hidden; etc.
 *
 * dropdownToggle - Provides dropdown menu functionality in place of bootstrap js
 * @restrict class or attribute
 * @example:
 *    <li class="gw-pl-dropdown-wrapper">
 *        <a class="gw-pl-dropdown-toggle"
 *          [closest-element-to-listen]
 *          [event-to-listen]
 *          >My Dropdown Menu</a>
 *        <div class="gw-pl-dropdown-menu-wrapper">
 *          <ul class="dropdown-menu">
 *              <li ng-repeat="choice in dropChoices">
 *                  <a ng-href="{{choice.href}}">{{choice.text}}</a>
 *              </li>
 *          </ul>
 *        </div>
 *    </li>
 *
 * Can use flavor="mobile" to get dropdown positioned over target.
 * Can use .gw-dropdown-menu_noarrow to get rid of arrow.
 */

var CYCLE_LIMIT = 10; // Max iterations refreshDropdownPosition is allowed to do to make position more precise
export default ['$document', function ($document) {
    var openElement = null;
    var _closeMenu = angular.noop;

    return {
        restrict: 'A',
        link: function link(scope, element, attrs) {
            // VARIABLES
            var $window = $(window);
            var $snapContainer = element.closest('.gw-snap-content-inner');
            var $elToAppendMenu = $snapContainer.length > 0 ? $snapContainer : element.closest('.gw-modal');

            var $dropdownWrapper = element.parent();
            var $dropdownMenuWrapper = $dropdownWrapper.find(attrs.gwPlDropdown || '.gw-pl-dropdown-menu-wrapper');
            var $dropdownMenu = $dropdownMenuWrapper.find('.gw-dropdown-menu');
            // elements for which "open" class would be added
            var $openClassEls = $dropdownWrapper.add($dropdownMenuWrapper);

            var $closestElementToListen = $();
            var eventToListen = void 0;
            if (attrs.closestElementToListen) {
                $closestElementToListen = element.closest(attrs.closestElementToListen);
                eventToListen = attrs.eventToListen;
            }

            // -----
            // ANGULAR BOOTSTRAP DROPDOWN DIRECTIVE CODE
            // -----
            scope.$watch('$location.path', function () {
                _closeMenu();
            });
            $dropdownWrapper.on('click', function () {
                _closeMenu();
            });
            element.on('click', function (event) {
                var elementWasOpen = element === openElement;

                event.preventDefault();
                event.stopPropagation();

                if (openElement) {
                    _closeMenu();
                }

                if (!elementWasOpen && !element.hasClass('gw-disabled') && !element.prop('disabled')) {
                    $openClassEls.addClass('gw-open');
                    openElement = element;
                    _closeMenu = function closeMenu() {
                        // if (event) {
                        //    event.preventDefault();
                        //    event.stopPropagation();
                        // }

                        $document.off('click', _closeMenu);

                        // additional code starts
                        $window.off('resize', _closeMenu);
                        $closestElementToListen.off(eventToListen, _closeMenu);
                        // additional code ends

                        $openClassEls.removeClass('gw-open');
                        _closeMenu = angular.noop;
                        openElement = null;

                        if (typeof scope._dropdownOnClose === 'function') {
                            scope._dropdownOnClose();
                        }
                    };

                    $document.on('click', _closeMenu);

                    // additional code starts
                    $window.on('resize', _closeMenu);
                    refreshDropdownPosition();
                    $closestElementToListen.on(eventToListen, _closeMenu);
                    $dropdownMenuWrapper.appendTo($elToAppendMenu);
                    // additional code ends

                    if (typeof scope._dropdownOnOpen === 'function') {
                        scope._dropdownOnOpen();
                    }
                }
            });

            // -----
            // ADDITIONAL CODE
            // -----
            $dropdownMenuWrapper.detach(); // detach element to prevent page size change on appearing

            function refreshDropdownPosition() {
                var cycle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

                var elToAppendMenuOffset = $elToAppendMenu.offset();
                var dropdownWrapperOffset = $dropdownWrapper.offset();

                var wrapperHeight = $dropdownWrapper.height();
                var top = dropdownWrapperOffset.top - elToAppendMenuOffset.top;
                if (attrs.flavor === 'mobile') {
                    // This positions a dropdown over a dropdown-trigger (use with gw-dropdown-menu_noarrow)
                    var elementWasOpen = element === openElement;
                    var menuHeight = $dropdownMenu.height();
                    if (elementWasOpen && menuHeight) {
                        top -= (menuHeight + wrapperHeight) / 2;
                    } else if (cycle < CYCLE_LIMIT) {
                        scope.$applyAsync(function () {
                            return refreshDropdownPosition(cycle + 1);
                        });
                    } else {
                        throw new Error('Could not properly determine dropdown position after ' + CYCLE_LIMIT + ' iterations');
                    }
                }

                $dropdownMenuWrapper.css({
                    width: $dropdownWrapper.width(),
                    height: wrapperHeight,
                    top: top,
                    left: dropdownWrapperOffset.left - elToAppendMenuOffset.left
                }).appendTo($elToAppendMenu);
            }
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/widgets/dropdown/directives/DropdownDirective.js
// module id = 1111
// module chunks = 0